import { fetchAction, fetchPostApi } from "../../../helpers/fetch";

export const createPaymentSession = (paymentDetails) =>
    fetchPostApi("/api/payment/session", paymentDetails);

export const createGuestPaymentSession = (paymentDetails) =>
    fetchPostApi("/api/webhook/guest-session", paymentDetails);

export const cancelSubscription = (subscriptionId) =>
    fetchPostApi(`/api/payment/subscriptions/${subscriptionId}`, {}, "DELETE");

export const getPaginatedPayments = (offset, limit, user_id, select_all = false, deduct_app_fees = false) => {
    const queryFilters = [`limit=${limit || 10}`, `offset=${offset || 0}`];
    if (user_id) {
        queryFilters.push(`user_id=${user_id}`);
    }
    if (select_all) {
        queryFilters.push("select_all=true");
    }
    if (deduct_app_fees) {
        queryFilters.push("deduct_app_fees=true");
    }
    const filter = queryFilters.join("&");

    return fetchAction(`/api/payment?${filter}`, [
        "GET_PAYMENTS_REQUEST",
        "GET_PAYMENTS_SUCCESS",
        "GET_PAYMENTS_FAILURE",
    ]);
};

export const getPaginatedSubscriptions = (offset, limit, user_id = null) => {
    const queryFilters = [`limit=${limit || 10}`, `offset=${offset || 0}`];
    if (user_id) {
        queryFilters.push(`user_id=${user_id}`);
    }
    const filter = queryFilters.join("&");

    return fetchAction(`/api/payment/subscriptions?${filter}`, [
        "GET_SUBSCRIPTIONS_REQUEST",
        "GET_SUBSCRIPTIONS_SUCCESS",
        "GET_SUBSCRIPTIONS_FAILURE",
    ]);
};
